import isClient from "./isClient";

const hasSessionStorage: () => boolean = () =>
  isClient() && typeof window.sessionStorage !== "undefined" && window.sessionStorage !== null;

export default hasSessionStorage;
